module.exports = __webpack_public_path__ + "media/images/emblems/Ursins-coat_of_arms-0b1e00c6226e9b12c9848a8fa1a5713e.svg";